import { stateIn } from 'xstate';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfDismissed = stateIn({ visibility: 'dismissed' });

const checkIfShown = stateIn({ visibility: 'shown' });

const checkIfInitiallyShown = () => false;

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfDismissed,
  checkIfShown,
  checkIfInitiallyShown,
};
